import { Button, Card, Image, Select } from "antd";
import { CardHeader } from "Components/Atoms/CardHeader";
import { useState } from "react";
import { toast } from "react-toastify";
import AdminServices from "services/api/AdminServices";
import brokerList from "StaticData/brokerList.json";

export default function UploadBrokerLogoToCDN() {

    const [uploadingImg, setUploadingImg] = useState(false);
    const [selectedBroker, setSelectedBroker] = useState({});
    const [file, setFile] = useState(null);
    const [imagePreview, setImagePreview] = useState(null);

    const handleFileInputChange = async (e) => {
        const selectedFile = e.target.files[0];
        if (selectedFile) {
            setFile(selectedFile);
            setImagePreview(URL.createObjectURL(selectedFile));
        }
    };

    const handleUpload = async () => {
        setUploadingImg(true);
        const data = new FormData();
        data.append('file', file);
        let res = await AdminServices.updateToS3({
            fileName: `brokerlogo_${selectedBroker?.value}.png`, data,
            folderName: 'app-images/imgs/sharpely-asset/BrokerLogos'
        });
        if (res?.type === true && res?.data === 'success') {
            toast.success('Image uploaded!');
        }
        else {
            toast.error('Something went wrong!');
        }
        setUploadingImg(false);
    }


    return (
        <main>
            <Card title={
                <CardHeader heading={'Upload Broker Logo'} />
            }>
                <div className="margin20Bottom">
                    <div className="textSM w-500 dark4 mb-2">Select broker</div>
                    <Select options={brokerList} value={selectedBroker?.value} onChange={(e) => {
                        setSelectedBroker(brokerList.find(broker => broker.value === e));
                    }} placeholder='Select broker' style={{ width: "min(100%, 15rem)" }} showSearch filterOption={(input, option) => {
                        return option?.label?.toLowerCase()?.includes(input?.toLowerCase());
                    }} />
                </div>
                <div className="margin20Bottom">
                    <input type="file" onChange={handleFileInputChange} accept="image/png" />
                    <div className="textSM w-500 mt-1">Note: Only .png format is supported.</div>
                </div>
                {imagePreview && <div className="margin20Bottom">
                    <Image src={imagePreview} style={{ width: "20rem" }} />
                </div>}
                <Button type="primary" disabled={!imagePreview} loading={uploadingImg} onClick={() => {
                    handleUpload();
                }}>Upload</Button>
            </Card>
        </main>
    )
}